import {getPublicationArticlesList, getAuthorArticlesList, getPublisherArticlesList, getAuthorTimeRange} from '@/libs/api/api'
import {isEmpty, cloneDeep} from 'lodash'
import {loader, message, errorHandler, logout} from '@/libs/helper'
import constants from '@/libs/constant/constants'
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom'
import DetailMenu from '@/components/pages/InformationPortal/ProfilePage/DetailMenu/DetailMenu.vue'
import mongoose from 'mongoose';

export default {
    name: 'Overview',
    components: {
        DetailMenu,
        'ArticleCard': () => import('@/components/pages/InformationPortal/ProfilePage/ArticleCard/ArticleCard.vue')
    },
    props: {
        module: {
            type: String
        },
        details: {
            type: Object,
            default: () => {}
        },
        fetchMetaDetails: {
            type: Function, 
            default: () => {}
        },
        changeUpdateArticleShareCount: {
            type: Function, 
            default: () => {}
        },
        updateArticleShareCount: {
            type: Object,
            default: () => {}
        },
        activateSharePopup: {
            type: Function,
            default: () => {}
        },
        // left menu
        selectedRecord: {
            type: Object,
            default: () => {}
        },
        followUnfollowAction: {
            type: Function,
            default: () => {}
        },
        createDetailShortUrl: {
            type: Function,
            default: () => {}
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        routeToDetailPage: {
            type: Function,
            default: () => {}
        },
        getIconClassName: {
            type: Function,
            default: () => {}
        },
        followCollection: {
            type: Function,
            default: () => {}
        },
        getShortUrlCollection: {
            type: Function,
            default: () => {}
        },
        routeToFollowers: {
            type: Function,
            default: () => {}
        },
        routeToCollectionAboutPage: {
            type: Function,
            default: () => {}
        },
        routeFromCollectionPage: {
            type: Function,
            default: () => {}
        },
        setFavourite: {
            type: Function,
            default: () => {}
        },
        articlesCount: {
            type: Number,
            default: 0
        },
        collectionCount: {
            type: Number,
            default: 0
        },
        followersCount: {
            type: Number,
            default: 0
        },
        collectionFollowersCount: {
            type: Number,
            default: 0
        },
        dossierCount: {
            type: Number,
            default: 0
        },
        collectionArticleCount: {
            type: Number,
            default: 0
        },
        isDossier: {
            type: Boolean,
            default: false
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        collectionShortUrl: {
            type: String,
            default: ''
        },
        shortUrl: {
            type: String,
            default: ''
        },
        routeToAboutPage: {
            type: Function,
            default: () => {}
        }
    },
    watch: {
        '$route' (to, from) {
            if (to.name === from.name && to.params && from.params && to.params.id !== from.params.id) {
                // to get the latest articles
                this.getLatestArticles()
                // to get the map data
                this.getMapData()
            } 
        },
        updateArticleShareCount (value) {
            if (!isEmpty(value)) this.updateArticleSharingCount(value)
        }
    },
    beforeMount() {
        this.getLatestArticles()
        this.windowSize = window.screen.width
    },
    mounted() {
        if (this.module && this.module === constants.AUTHOR.key) {
            this.getMapData()
        }
    },
    data() {
        return {
            articles: [],
            isEmpty,
            chart: {},
            year: new Date().getFullYear(),
            max: new Date().getFullYear(),
            min: null,
            windowSize: null,
            articleToBeAddedinDocuments: '',
            articleToBeShared: ''
        }
    },
    methods: {
        /**
         * to get the latest articles 
         * to show on the overview page
         */
        getLatestArticles: async function () {
            loader(this, true)
            // params for api
            let params = {
                skip: 0,
                limit: 3,
                sort: 'pub_date',
                order: 'desc'
            }

            // body 
            let body = await this.getBody()
            
            // api call
            this.getArticles(this.module, params, body).then(response => {
                this.articles = response.items || []
                loader(this, false)
            }).catch(error => {
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * api call
         */
        getArticles (module, params, body) {
            switch (module) {
                case constants.AUTHOR.key:
                    return getAuthorArticlesList(params, body)
                case constants.PUBLISHER.key:
                    return getPublisherArticlesList(params, body)
                case constants.PUBLICATION.key:
                    return getPublicationArticlesList(params, body)
            }
        },
        /**
         * to get the body for 
         * api based on module
         */
        getBody () {
            let body = {}
            if (this.module === 'AUTHOR') body.author_id = this.$route.params.id
            else if (this.module === 'PUBLICATION') body.publication_id = this.$route.params.id
            else if (this.module === 'PUBLISHER') body.publisher_id = this.$route.params.id
            return body
        },

        /**
         * to embed the chart in the overview page of author
         */
        getMapData: async function () {
            try {
                this.getTimeRange()
                this.year = new Date().getFullYear()
                // mongo object for author id
                const mongoObj = new mongoose.Types.ObjectId(this.$route.params.id)
                // setting up tha dates
                let now = new Date();
                let previous = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
                // filter for the chart
                let filter = {
                    $and: [
                        { pub_date: { $gte: previous } },
                        { pub_date: { $lte: now } },
                        {"authors.author": mongoObj}
                      ],
                }
                // creating a instance of ChartsEmbedSDK
                const sdk = new ChartsEmbedSDK({
                    baseUrl: 'https://charts.mongodb.com/charts-sunflower-ulrkw',
                  });
                // instantiating chart with chart-id and filter
                const chart = sdk.createChart({
                  chartId: process.env.VUE_APP_CHART_ID,
                  showAttribution: false,
                  filter
                });
                  // saving the data
                  this.chart = chart                  
                  // render the chart into a container
                  if (document.getElementById('chart') && document.getElementById('chart') !== null) {
                    await chart
                    .render(document.getElementById('chart'))
                    .catch(() => message(this, constants.messageType.ERROR, 'Chart failed to initialise'));
                  }
            } catch (error) {
                console.error('chart error', error)
            }
        },
        /**
         * to handle the filter
         * @param {*} value value passed
         */
        handleFilters (value) {
            //to set the filter
            if (value && (value.toString().length === 4)) {
                // mongo object id for the author id to be passed in filter
                const mongoObj = new mongoose.Types.ObjectId(this.$route.params.id)
                let filter = {}
                // if it is the current year
                if (value === this.max) {
                    // current yr
                    let now = new Date();
                    // previou yr
                    let previous = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
                    // filter object
                    filter = {
                        $and: [
                            { pub_date: { $gte: previous } },
                            { pub_date: { $lte: now } },
                            {"authors.author": mongoObj}
                        ],
                    }
                    
                } else {
                    // filter object if the it is not the current yr
                    filter = {
                        $and: [
                            { pub_date: { $gte: new Date(value, 0, 1) } },
                            { pub_date: { $lte: new Date(value, 11, 31) } },
                            {"authors.author": mongoObj}
                        ],
                    }
                }
                // applying he filter
                this.chart.setFilter(filter)
            }
        },
        /**
         * to get the records of articles time range of author
         */
        getTimeRange: async function () {
            try {
                // path for the api
                let path = `${this.module.toLowerCase()}/${this.$route.params.id}`
                // api call
                let response = await getAuthorTimeRange(path)
                if (response && response.oldData && response.oldData.pub_date) {
                    this.min = new Date(response.oldData.pub_date).getFullYear()
                }
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        },
        /**
         * update the article results
         * @param {*} articleToUpdate 
         */
        updateArticleFavorite (articleToUpdate) {
            let articles = cloneDeep(this.articles)
            this.articles = articles.map(article => {
                if (article._id === articleToUpdate._id) article.favorites = articleToUpdate.favorites || []
                return article
            })
        },
        /**
         * to show the add documents section
         * @param {*} id 
         */
        showAddToDocuments (id) {
            this.articleToBeAddedinDocuments = id ? id : ''
        },
        /**
         * to update when clicked on add to Documents 
         * @param {*} articleToUpdate 
         */
        updateArticleCatalog (articleToUpdate) {
            let articles = cloneDeep(this.articles)
            this.articles = articles.map(article => {
                if (article._id === articleToUpdate._id) article.added_via_extension = articleToUpdate.added_via_extension
                return article
            })
        },
        /**
         * update article share count
         * @param {*} articleToUpdate 
         */
        updateArticleSharingCount (articleToUpdate) {
            let articlesToDisplay = cloneDeep(this.articlesToDisplay)
            this.articlesToDisplay = articlesToDisplay.map(article => {
                if (article._id === articleToUpdate._id) article.sharing_count = (articleToUpdate.sharing_count || 0) + 1
                return article
            })
            this.changeUpdateArticleShareCount({})
        },
        /**
         * to open up the share article flow
         * @param {*} id 
         */
        changeShareArticle (id) {
            this.articleToBeShared = this.articleToBeShared === id ? '' : id
        },
    }
}